<template>
  <header class="jd-hero hp-animate">
    <div v-if="loading" class="jd-hero__skeleton">
      <content-loader viewBox="0 0 800 120" primaryColor="#f1f5f9" secondaryColor="#e2e8f0">
        <rect x="0" y="0" rx="12" ry="12" width="72" height="72" />
        <rect x="96" y="8" rx="4" ry="4" width="320" height="20" />
        <rect x="96" y="40" rx="4" ry="4" width="180" height="14" />
        <rect x="96" y="64" rx="4" ry="4" width="240" height="12" />
      </content-loader>
    </div>

    <div v-else-if="job" class="jd-hero__inner">
      <div class="jd-hero__main">
        <div class="jd-hero__logo" v-if="job.company_logo_url">
          <img :src="$S3_url + job.company_logo_url" :alt="job.company_name + ' logo'" />
        </div>
        <div class="jd-hero__logo jd-hero__logo--placeholder" v-else>
          {{ (job.company_name || 'J').charAt(0) }}
        </div>

        <div class="jd-hero__copy">
          <h1 class="jd-hero__title">{{ job.job_designation }}</h1>
          <p class="jd-hero__company">{{ job.company_name }}</p>
          <div class="jd-hero__chips">
            <span class="jd-chip" v-if="jobType">
              <v-icon size="14">{{ $icons.layers }}</v-icon>
              {{ jobType }}
            </span>
            <span class="jd-chip" v-if="job.cities && job.cities.length">
              <v-icon size="14">{{ $icons.mapMarker }}</v-icon>
              {{ job.cities.join(', ') }}
            </span>
            <span class="jd-chip" v-if="salaryText">
              <v-icon size="14">{{ $icons.cashMultiple }}</v-icon>
              {{ salaryText }}
            </span>
            <span class="jd-chip" v-if="job.hiring_process">{{ job.hiring_process }}</span>
            <span class="jd-chip jd-chip--muted" v-if="postedDate">Posted {{ postedDate }}</span>
            <span class="jd-chip jd-chip--warn" v-if="job.last_date">Apply by {{ job.last_date }}</span>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  name: 'JobDetailHero',
  components: { ContentLoader },
  props: {
    job: { type: Object, default: null },
    loading: { type: Boolean, default: true },
    jobType: { type: String, default: '' },
    postedDate: { type: String, default: '' },
  },
  computed: {
    salaryText() {
      if (!this.job || this.job.salary_flag || (!this.job.salary_range_from && !this.job.salary_range_to)) {
        return '';
      }
      let text = '₹' + this.job.salary_range_from;
      if (this.job.salary_range_to) {
        text += ' – ₹' + this.job.salary_range_to;
      }
      return text + '/month';
    },
  },
};
</script>
